import React from 'react'

import { i18n } from '~/i18n'

import { CapitalizedSpan } from './credit-card.styles'
import { creditCardExpired } from '../../utils/credit-card'
import { stringifyDate } from '../../utils/date'

import type { TokenizedCreditCard } from '../../types'

type Props = {
  creditCard: TokenizedCreditCard
}

const CreditCard = (props: Props) => {
  const isExpired = (): boolean => {
    return creditCardExpired(props.creditCard)
  }

  const renderCreditCardEnding = (): string | null | undefined => {
    const { creditCard } = props
    return i18n.t('components.credit_card.summary', {
      last_four_digits: creditCard.lastFourDigits,
    })
  }

  const renderCreditCardExpiry = (): string | null | undefined => {
    const { creditCard } = props
    const expiryDate = stringifyDate({
      year: creditCard.year,
      month: Number(creditCard.month) - 1,
      day: '1',
    })

    const translationKey = isExpired()
      ? 'components.credit_card.expired'
      : 'components.credit_card.expiry'

    return i18n.t(translationKey, {
      date: i18n.l('date.formats.expiry', expiryDate),
    })
  }

  return (
    <>
      <CapitalizedSpan>{props.creditCard.cardType + ' '}</CapitalizedSpan>
      <CapitalizedSpan>{renderCreditCardEnding()}</CapitalizedSpan>
      <div>
        <CapitalizedSpan $expired={isExpired()}>
          {renderCreditCardExpiry()}
        </CapitalizedSpan>
      </div>
    </>
  )
}

export default CreditCard
